// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"0b335e2f","307":"ff67c9be","708":"88209df8","755":"a1e9747f","932":"f5307676","971":"6c05daf9","972":"c0e4849b"}[chunkId] + ".chunk.js";
};